module.exports = __webpack_public_path__ + "home_all_electric.356ecf7e461f1e4efe9c.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/home_all_electric.png
// module id = ../../../../../src/assets/img/home_all_electric.png
// module chunks = styles